import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-02c50263"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "padding": "10px",
    "height": "40px"
  },
  alt: "LOGO"
}, null, -1));
const _hoisted_2 = {
  key: 0,
  class: "logo2"
};
const _hoisted_3 = {
  class: "header-center-content"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = {
  key: 1,
  class: "item"
};
const _hoisted_8 = {
  class: "info"
};
const _hoisted_9 = {
  class: "copyright"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  const _component_el_badge = _resolveComponent("el-badge");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_layout_header = _resolveComponent("layout-header");
  const _component_el_header = _resolveComponent("el-header");
  const _component_layout_aside = _resolveComponent("layout-aside");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_layout_main_tag = _resolveComponent("layout-main-tag");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_container, {
    class: "home"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      style: {
        "--el-header-padding": "0"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_layout_header, {
        onCollapseChange: $options.collapseChange,
        collapse: $data.collapse
      }, {
        headerLogo: _withCtx(() => [_createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            justify: "left"
          }, {
            default: _withCtx(() => [_hoisted_1, !$data.collapse ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.productName), 1)) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        headerCenter: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, item => {
          return _openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["header-menu", {
              'header-menu-selected': $data.currentMenuId === item.permissionId
            }]),
            key: item.permissionId,
            onClick: $event => $options.changeToMenu(item, true)
          }, [item.icon && item.icon.startsWith('http') ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "menu-image",
            src: item.icon
          }, null, 8, _hoisted_5)) : item.icon ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: _normalizeClass(["iconfont", item.icon])
          }, null, 8, ["class"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.permissionName), 1)], 10, _hoisted_4);
        }), 128))])]),
        headerRight: _withCtx(() => [_createVNode(_component_el_config_provider, {
          locale: $data.locale
        }, null, 8, ["locale"]), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [$data.taskCount > 0 ? (_openBlock(), _createBlock(_component_el_popover, {
            key: 0,
            trigger: "click",
            onShow: $options.loadTask,
            width: "480px"
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_badge, {
              value: $data.taskCount,
              max: 99,
              class: "badge"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "iconfont icon-bell",
                size: "18px"
              })]),
              _: 1
            }, 8, ["value"])])]),
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: $data.taskList
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                width: "150px",
                property: "name",
                label: "任务名称"
              }), _createVNode(_component_el_table_column, {
                width: "150px",
                label: "类型"
              }, {
                default: _withCtx(scope => [scope.row.processDefinitionKey === 'record_representation' ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0
                }, {
                  default: _withCtx(() => [_createTextVNode(" 骑行记录申述 ")]),
                  _: 1
                })) : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.processDefinitionKey), 1)]),
                  _: 2
                }, 1024))]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                property: "createTime",
                label: "创建时间"
              })]),
              _: 1
            }, 8, ["data"])), [[_directive_loading, $data.taskListLoading]])]),
            _: 1
          }, 8, ["onShow"])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_icon, {
            class: "iconfont icon-bell",
            size: "18px"
          })])), _createVNode(_component_el_dropdown, {
            class: "user-info item",
            onCommand: $options.userInfoHandleCommand
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                command: "changePwd"
              }, {
                default: _withCtx(() => [_createTextVNode("修改密码")]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                divided: "",
                command: "logout"
              }, {
                default: _withCtx(() => [_createTextVNode("退出登录")]),
                _: 1
              })]),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_8, "欢迎您：" + _toDisplayString(_ctx.userName), 1)]),
            _: 1
          }, 8, ["onCommand"]), _createVNode(_component_el_tooltip, {
            content: $data.isFullScreenIng ? '退出全屏' : '进入全屏'
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              class: "help item",
              onClick: _cache[0] || (_cache[0] = (...args) => $options.fullScreen && $options.fullScreen(...args))
            }, [_createVNode(_component_el_icon, {
              class: _normalizeClass(["iconfont icon-fullscreen", {
                'icon-fullscreen-exit': $data.isFullScreenIng
              }]),
              size: "18px"
            }, null, 8, ["class"])])]),
            _: 1
          }, 8, ["content"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["onCollapseChange", "collapse"])]),
      _: 1
    }), _createVNode(_component_el_aside, {
      class: _normalizeClass(["layout-aside", {
        'aside-collapse': $data.collapse
      }])
    }, {
      default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [_createVNode(_component_layout_aside, {
          collapse: $data.collapse,
          menus: $data.currentMenus,
          onMenuClick: $options.menuClick
        }, null, 8, ["collapse", "menus", "onMenuClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["class"]), _createVNode(_component_el_main, {
      class: _normalizeClass(["layout-main", {
        'layout-main-collapse': $data.collapse,
        'layout-main-to-collapse': $data.collapseAnimation && $data.collapse,
        'layout-main-from-collapse': $data.collapseAnimation && !$data.collapse
      }])
    }, {
      default: _withCtx(() => [_createVNode(_component_layout_main_tag, {
        ref: "mainTag"
      }, null, 512), _createVNode(_component_el_scrollbar, {
        class: "main-scrollbar"
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, {
          onChangeTopToMenu: $options.changeToMenu,
          topMenuId: $data.currentMenuId,
          topMenuClick: $data.currentMenuClick,
          onLoadTaskCount: $options.loadTaskCount
        }, {
          default: _withCtx(({
            Component
          }) => [(_openBlock(), _createBlock(_KeepAlive, {
            include: $options.keepAliveCache
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
          _: 1
        }, 8, ["onChangeTopToMenu", "topMenuId", "topMenuClick", "onLoadTaskCount"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(_ctx.copyRight), 1)])]),
        _: 1
      })]),
      _: 1
    }, 8, ["class"])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    title: "修改密码",
    modelValue: $data.changePwdDialog,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.changePwdDialog = $event),
    width: "40%",
    "close-on-click-modal": false,
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [_createVNode(_component_el_row, {
      justify: "center"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.doChangePwd
      }, {
        default: _withCtx(() => [_createTextVNode("确定")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = $event => $data.changePwdDialog = false)
      }, {
        default: _withCtx(() => [_createTextVNode("取消")]),
        _: 1
      })]),
      _: 1
    })]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.changePwdForm,
      ref: "pwdForm",
      rules: $data.changePwdFormRules,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "原密码",
        prop: "oldPwd"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.changePwdForm.oldPwd,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.changePwdForm.oldPwd = $event),
          "auto-complete": "off",
          type: "password"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "新密码",
        prop: "newPwd"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          type: "password",
          modelValue: $data.changePwdForm.newPwd,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.changePwdForm.newPwd = $event),
          "auto-complete": "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "确认密码",
        prop: "newPwd1"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          type: "password",
          modelValue: $data.changePwdForm.newPwd1,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.changePwdForm.newPwd1 = $event),
          "auto-complete": "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}